import { styled } from '@mui/material';
import { addOpacity } from 'lib/helpers';
import React from 'react';

const StyledDiv = styled('div', { shouldForwardProp: prop => prop !== 'filled' && prop !== 'active' })<{
    filled?: boolean;
    active?: boolean;
}>(({ theme, filled, active }) => ({
    width: '100%',
    height: '0.8em',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: filled ? theme.palette.primary.main : addOpacity(theme.palette.primary.main, 0.5),
    position: 'relative',
    overflow: 'hidden',
    '@keyframes pulse-in': {
        '0%': { width: '0%', opacity: 0 },
        '80%': { width: '100%', opacity: 1 },
        '98%': {
            width: '100%',
            opacity: 0
        },
        '100%': { width: '0%', opacity: 0 }
    },
    '&:after': {
        position: 'absolute',
        background: theme.palette.primary.main,
        borderRadius: theme.shape.borderRadius,
        left: 0,
        top: 0,
        height: '100%',
        content: '""',
        animation: active ? 'pulse-in 2s ease-in-out infinite' : undefined,
        animationDelay: '0.5s'
    }
}));

interface AnimatedBarProps {
    active?: boolean;
    filled?: boolean;
}

export const AnimatedBar: React.FC<AnimatedBarProps> = ({ active, filled }) => (
    <StyledDiv filled={filled} active={active} />
);
